// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   Projects Page
   
   Design System: Uses CSS variables from colors.css
   - Neutral base palette, accent reserved for primary actions only
   - Flat surfaces with borders (no gradients)
   - Minimal shadows, minimal border radii
   - Compact spacing
   ====================== */

.projects-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px;
  min-height: 100%;
  width: 100%;
  box-sizing: border-box;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: var(--color-bg-root);
}

/* ======================
   HEADER
   ====================== */

.projects-header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.projects-title {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.projects-new-button {
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.projects-new-button:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.projects-new-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.projects-new-button-large {
  padding: 10px 20px;
  font-size: 14px;
  margin-top: 16px;
}

/* ======================
   DROPDOWN MENU
   ====================== */

.projects-dropdown-content {
  min-width: 200px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  padding: 4px;
  z-index: 2000;
}

.projects-dropdown-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: transparent;
  border: none;
  border-radius: 3px;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  transition: background 0.15s ease;
  width: 100%;
  text-align: left;
  outline: none;
}

.projects-dropdown-item:hover,
.projects-dropdown-item:focus {
  background: var(--color-bg-user-bubble);
}

.projects-dropdown-label {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.projects-dropdown-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-primary);
}

.projects-dropdown-desc {
  font-size: 11px;
  color: var(--color-text-secondary);
}

/* ======================
   ERROR
   ====================== */

.projects-error {
  background: rgba(192, 57, 43, 0.1);
  border: 1px solid rgba(192, 57, 43, 0.2);
  color: #c0392b;
  padding: 10px 14px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 13px;
  font-weight: 500;
}

/* ======================
   LOADING
   ====================== */

.projects-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: var(--color-text-secondary);
}

.projects-loading-spinner {
  width: 32px;
  height: 32px;
  border: 2px solid var(--color-border-input);
  border-top-color: var(--color-text-secondary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ======================
   EMPTY STATE
   ====================== */

.projects-empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--color-text-secondary);
}

.projects-empty-state h2 {
  font-size: 20px;
  font-weight: 500;
  color: var(--color-text-primary);
  margin-bottom: 8px;
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.projects-empty-state p {
  font-size: 13px;
  margin-bottom: 16px;
}

/* ======================
   FILTERS
   ====================== */

.projects-filters {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.projects-search {
  flex: 1 1;
  min-width: 180px;
}

.projects-search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  font-size: 13px;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  transition: border-color 0.15s ease;
  box-sizing: border-box;
}

.projects-search-input:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.projects-search-input::placeholder {
  color: var(--color-text-secondary);
}

.projects-status-filter {
  flex-shrink: 0;
}

.projects-filter-tabs {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
}

.projects-filter-tab {
  padding: 6px 12px;
  border: none;
  border-radius: 3px;
  background: transparent;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.projects-filter-tab:hover:not(.active) {
  color: var(--color-text-primary);
}

.projects-filter-tab.active {
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
}

/* ======================
   PROJECT LIST
   ====================== */

.projects-list {
  width: 100%;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  border-radius: 12px;
  background: var(--color-bg-canvas-surface);
  box-sizing: border-box;
  transition: opacity 700ms cubic-bezier(0.32, 0.72, 0, 1);
}

.projects-list.is-loading {
  opacity: 0.55;
  pointer-events: none;
}

.projects-list-header,
.projects-row {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(120px, 0.75fr) 104px 96px 104px 32px;
  align-items: center;
  gap: 12px;
}

.projects-list-header {
  padding: 8px 16px;
  border-bottom: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
}

.projects-row {
  min-height: 72px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
  cursor: pointer;
  box-sizing: border-box;
  transition: background 700ms cubic-bezier(0.32, 0.72, 0, 1), transform 700ms cubic-bezier(0.32, 0.72, 0, 1);
}

.projects-row:last-child {
  border-bottom: 0;
}

.projects-row:hover {
  background: var(--color-bg-user-bubble);
}

.projects-row:active {
  transform: scale(0.995);
}

.projects-row:focus-visible,
.projects-row.is-highlighted {
  outline: 2px solid var(--color-text-secondary);
  outline-offset: -2px;
}

.projects-row-project,
.projects-row-creator,
.projects-creator-name {
  min-width: 0;
}

.projects-row-title {
  margin: 0;
  overflow: hidden;
  color: var(--color-text-primary);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.projects-row-updated,
.projects-row-date,
.projects-row-cost {
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 16px;
}

.projects-row-updated {
  display: block;
  margin-top: 4px;
}

.projects-row-progress {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  max-width: 240px;
  margin-top: 8px;
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 16px;
}

.projects-row-progress-track {
  height: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: var(--color-border-input);
}

.projects-row-progress-fill {
  height: 100%;
  border-radius: inherit;
  background: #d69a44;
  transition: width 700ms cubic-bezier(0.32, 0.72, 0, 1);
}

.projects-row-creator {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.projects-creator-avatar {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.projects-creator-name {
  overflow: hidden;
  font-size: 12px;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.projects-row-status {
  min-width: 0;
}

.projects-row-actions-button {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background 700ms cubic-bezier(0.32, 0.72, 0, 1), color 700ms cubic-bezier(0.32, 0.72, 0, 1), transform 700ms cubic-bezier(0.32, 0.72, 0, 1);
}

.projects-row-actions-button:hover,
.projects-row-actions-button:focus-visible {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

.projects-row-actions-button:active {
  transform: scale(0.98);
}

.projects-mobile-label {
  display: none;
}

/* Loading skeleton shaped like the list it replaces. */
.projects-skeleton-row {
  cursor: default;
}

.projects-skeleton-row:hover {
  background: transparent;
}

.projects-skeleton-line {
  height: 12px;
  border-radius: 4px;
  background: var(--color-bg-user-bubble);
  animation: projects-skeleton-pulse 1.6s ease-in-out infinite;
}

.projects-skeleton-project { width: 72%; }
.projects-skeleton-creator { width: 80%; }
.projects-skeleton-status { width: 64%; }
.projects-skeleton-date { width: 72%; }
.projects-skeleton-cost { width: 56%; }

@keyframes projects-skeleton-pulse {
  0%, 100% { opacity: 0.45; }
  50% { opacity: 0.9; }
}

@media (prefers-reduced-motion: reduce) {
  .projects-skeleton-line {
    animation: none;
  }
}

/* Status badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  flex-shrink: 0;
}

.status-badge::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--color-text-secondary);
}

.status-completed::before {
  background: #4f9f6c;
}

.status-processing::before {
  background: #d69a44;
}

.status-failed::before {
  background: #c85e55;
}

.status-unknown::before {
  background: var(--color-text-secondary);
}

/* ======================
   PAGINATION
   ====================== */

.projects-pagination {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--color-border-input);
}

.projects-pagination-info {
  font-size: 11px;
  color: var(--color-text-secondary);
  font-weight: 400;
}

.projects-pagination-controls {
  display: flex;
  align-items: center;
  gap: 6px;
}

.projects-pagination-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: transparent;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  cursor: pointer;
  transition: background 0.15s ease;
}

.projects-pagination-btn:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.projects-pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.projects-pagination-pages {
  display: flex;
  align-items: center;
  gap: 2px;
}

.projects-pagination-page {
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.projects-pagination-page:hover:not(.active) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.projects-pagination-page.active {
  background: var(--color-bg-input);
  border-color: var(--color-border-input);
  color: var(--color-text-primary);
  font-weight: 600;
}

.projects-pagination-ellipsis {
  min-width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  font-size: 12px;
}

/* ======================
   LANDING MODAL
   ====================== */

.projects-landing-modal {
  position: fixed;
  inset: 0;
  background: var(--color-bg-root);
  z-index: 1000;
  overflow-y: auto;
}

.projects-landing-modal-close {
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 1001;
  padding: 8px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.projects-landing-modal-close:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* ======================
   CARD CONTEXT MENU
   ====================== */

.projects-context-menu-content {
  min-width: 160px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  padding: 4px;
  z-index: 2000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: projects-context-menu-fade 0.1s ease;
}

@keyframes projects-context-menu-fade {
  from { opacity: 0; transform: scale(0.97); }
  to   { opacity: 1; transform: scale(1); }
}

.projects-context-menu-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
  color: var(--color-text-primary);
}

.projects-context-menu-item[data-highlighted] {
  background: var(--color-bg-user-bubble);
}

.projects-context-menu-item-destructive {
  color: #c0392b;
}

.projects-context-menu-item-destructive[data-highlighted] {
  background: rgba(192, 57, 43, 0.08);
}

/* ======================
   DELETE CONFIRMATION DIALOG
   ====================== */

.projects-delete-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.projects-delete-dialog {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  padding: 24px;
  width: 340px;
  max-width: calc(100vw - 32px);
}

.projects-delete-dialog-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
}

.projects-delete-dialog-body {
  margin: 0 0 20px;
  font-size: 13px;
  color: var(--color-text-secondary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  line-height: 1.5;
}

.projects-delete-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.projects-delete-dialog-cancel {
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: transparent;
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.projects-delete-dialog-cancel:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.projects-delete-dialog-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.projects-delete-dialog-confirm {
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: rgba(192, 57, 43, 0.1);
  color: #c0392b;
  border: 1px solid rgba(192, 57, 43, 0.25);
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.projects-delete-dialog-confirm:hover:not(:disabled) {
  background: rgba(192, 57, 43, 0.18);
}

.projects-delete-dialog-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ======================
   RESPONSIVE
   ====================== */

@media (max-width: 900px) {
  .projects-list-header {
    display: none;
  }

  .projects-row {
    grid-template-columns: minmax(0, 1fr) 32px;
    align-items: start;
    gap: 12px;
    min-height: 0;
    padding: 16px;
  }

  .projects-row-project {
    grid-column: 1;
  }

  .projects-row-actions-button {
    grid-column: 2;
    grid-row: 1;
  }

  .projects-row-creator,
  .projects-row-status,
  .projects-row-date,
  .projects-row-cost {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: 96px minmax(0, 1fr);
    align-items: center;
    gap: 8px;
  }

  .projects-row-creator {
    grid-template-columns: 96px 24px minmax(0, 1fr);
  }

  .projects-mobile-label {
    display: inline;
    color: var(--color-text-secondary);
    font-size: 12px;
    line-height: 16px;
  }

  .projects-skeleton-row {
    grid-template-columns: 1fr;
  }

  .projects-skeleton-row > :not(:first-child) {
    display: none;
  }
}

@media (max-width: 720px) {
  .projects-content {
    padding: 20px 16px;
  }

  .projects-header-section {
    flex-direction: column;
    align-items: stretch;
  }

  .projects-new-button {
    width: 100%;
  }

  .projects-filters {
    flex-direction: column;
  }

  .projects-search,
  .projects-status-filter {
    width: 100%;
  }

  .projects-pagination-controls {
    flex-wrap: wrap;
    justify-content: center;
  }

  .projects-pagination-btn {
    padding: 6px 10px;
    font-size: 11px;
  }

  .projects-pagination-page {
    min-width: 26px;
    height: 26px;
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ProjectsPage.css"],"names":[],"mappings":"AAAA;;;;;;;;2BAQ2B;;AAE3B;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,8EAA8E;EAC9E,gCAAgC;AAClC;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8EAA8E;EAC9E,iCAAiC;EACjC,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;2BAE2B;;AAE3B;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,8EAA8E;EAC9E,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;;2BAE2B;;AAE3B;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gCAAgC;EAChC,8EAA8E;EAC9E,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,8EAA8E;EAC9E,eAAe;EACf,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;;2BAE2B;;AAE3B;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qFAAqF;EACrF,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kDAAkD;EAClD,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,2GAA2G;AAC7G;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;EACvC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,uJAAuJ;AACzJ;;AAEA;;EAEE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,uDAAuD;AACvD;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,4DAA4D;AAC9D;;AAEA,6BAA6B,UAAU,EAAE;AACzC,6BAA6B,UAAU,EAAE;AACzC,4BAA4B,UAAU,EAAE;AACxC,0BAA0B,UAAU,EAAE;AACtC,0BAA0B,UAAU,EAAE;;AAEtC;EACE,WAAW,aAAa,EAAE;EAC1B,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,8EAA8E;EAC9E,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,8EAA8E;EAC9E,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;2BAE2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,8EAA8E;EAC9E,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;2BAE2B;;AAE3B;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8EAA8E;EAC9E,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;2BAE2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,8EAA8E;EAC9E,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8EAA8E;EAC9E,uBAAuB;EACvB,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8EAA8E;EAC9E,kCAAkC;EAClC,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,0CAA0C;IAC1C,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;;;;IAIE,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* ======================\n   Projects Page\n   \n   Design System: Uses CSS variables from colors.css\n   - Neutral base palette, accent reserved for primary actions only\n   - Flat surfaces with borders (no gradients)\n   - Minimal shadows, minimal border radii\n   - Compact spacing\n   ====================== */\n\n.projects-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px 24px;\n  min-height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: var(--color-bg-root);\n}\n\n/* ======================\n   HEADER\n   ====================== */\n\n.projects-header-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.projects-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.projects-new-button {\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.projects-new-button:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.projects-new-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.projects-new-button-large {\n  padding: 10px 20px;\n  font-size: 14px;\n  margin-top: 16px;\n}\n\n/* ======================\n   DROPDOWN MENU\n   ====================== */\n\n.projects-dropdown-content {\n  min-width: 200px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  padding: 4px;\n  z-index: 2000;\n}\n\n.projects-dropdown-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  cursor: pointer;\n  user-select: none;\n  background: transparent;\n  border: none;\n  border-radius: 3px;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  transition: background 0.15s ease;\n  width: 100%;\n  text-align: left;\n  outline: none;\n}\n\n.projects-dropdown-item:hover,\n.projects-dropdown-item:focus {\n  background: var(--color-bg-user-bubble);\n}\n\n.projects-dropdown-label {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.projects-dropdown-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n}\n\n.projects-dropdown-desc {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n}\n\n/* ======================\n   ERROR\n   ====================== */\n\n.projects-error {\n  background: rgba(192, 57, 43, 0.1);\n  border: 1px solid rgba(192, 57, 43, 0.2);\n  color: #c0392b;\n  padding: 10px 14px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* ======================\n   LOADING\n   ====================== */\n\n.projects-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: var(--color-text-secondary);\n}\n\n.projects-loading-spinner {\n  width: 32px;\n  height: 32px;\n  border: 2px solid var(--color-border-input);\n  border-top-color: var(--color-text-secondary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: 12px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ======================\n   EMPTY STATE\n   ====================== */\n\n.projects-empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--color-text-secondary);\n}\n\n.projects-empty-state h2 {\n  font-size: 20px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  margin-bottom: 8px;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.projects-empty-state p {\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n/* ======================\n   FILTERS\n   ====================== */\n\n.projects-filters {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.projects-search {\n  flex: 1;\n  min-width: 180px;\n}\n\n.projects-search-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  font-size: 13px;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  transition: border-color 0.15s ease;\n  box-sizing: border-box;\n}\n\n.projects-search-input:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.projects-search-input::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.projects-status-filter {\n  flex-shrink: 0;\n}\n\n.projects-filter-tabs {\n  display: flex;\n  gap: 2px;\n  padding: 2px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n}\n\n.projects-filter-tab {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 3px;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n}\n\n.projects-filter-tab:hover:not(.active) {\n  color: var(--color-text-primary);\n}\n\n.projects-filter-tab.active {\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n}\n\n/* ======================\n   PROJECT LIST\n   ====================== */\n\n.projects-list {\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  border-radius: 12px;\n  background: var(--color-bg-canvas-surface);\n  box-sizing: border-box;\n  transition: opacity 700ms cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n.projects-list.is-loading {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.projects-list-header,\n.projects-row {\n  display: grid;\n  grid-template-columns: minmax(180px, 1fr) minmax(120px, 0.75fr) 104px 96px 104px 32px;\n  align-items: center;\n  gap: 12px;\n}\n\n.projects-list-header {\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.projects-row {\n  min-height: 72px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  box-sizing: border-box;\n  transition: background 700ms cubic-bezier(0.32, 0.72, 0, 1), transform 700ms cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n.projects-row:last-child {\n  border-bottom: 0;\n}\n\n.projects-row:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.projects-row:active {\n  transform: scale(0.995);\n}\n\n.projects-row:focus-visible,\n.projects-row.is-highlighted {\n  outline: 2px solid var(--color-text-secondary);\n  outline-offset: -2px;\n}\n\n.projects-row-project,\n.projects-row-creator,\n.projects-creator-name {\n  min-width: 0;\n}\n\n.projects-row-title {\n  margin: 0;\n  overflow: hidden;\n  color: var(--color-text-primary);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.projects-row-updated,\n.projects-row-date,\n.projects-row-cost {\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.projects-row-updated {\n  display: block;\n  margin-top: 4px;\n}\n\n.projects-row-progress {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 8px;\n  max-width: 240px;\n  margin-top: 8px;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.projects-row-progress-track {\n  height: 4px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: var(--color-border-input);\n}\n\n.projects-row-progress-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: #d69a44;\n  transition: width 700ms cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n.projects-row-creator {\n  display: grid;\n  grid-template-columns: 24px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n}\n\n.projects-creator-avatar {\n  width: 24px;\n  height: 24px;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.projects-creator-name {\n  overflow: hidden;\n  font-size: 12px;\n  line-height: 16px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.projects-row-status {\n  min-width: 0;\n}\n\n.projects-row-actions-button {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background 700ms cubic-bezier(0.32, 0.72, 0, 1), color 700ms cubic-bezier(0.32, 0.72, 0, 1), transform 700ms cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n.projects-row-actions-button:hover,\n.projects-row-actions-button:focus-visible {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n.projects-row-actions-button:active {\n  transform: scale(0.98);\n}\n\n.projects-mobile-label {\n  display: none;\n}\n\n/* Loading skeleton shaped like the list it replaces. */\n.projects-skeleton-row {\n  cursor: default;\n}\n\n.projects-skeleton-row:hover {\n  background: transparent;\n}\n\n.projects-skeleton-line {\n  height: 12px;\n  border-radius: 4px;\n  background: var(--color-bg-user-bubble);\n  animation: projects-skeleton-pulse 1.6s ease-in-out infinite;\n}\n\n.projects-skeleton-project { width: 72%; }\n.projects-skeleton-creator { width: 80%; }\n.projects-skeleton-status { width: 64%; }\n.projects-skeleton-date { width: 72%; }\n.projects-skeleton-cost { width: 56%; }\n\n@keyframes projects-skeleton-pulse {\n  0%, 100% { opacity: 0.45; }\n  50% { opacity: 0.9; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .projects-skeleton-line {\n    animation: none;\n  }\n}\n\n/* Status badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0;\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  flex-shrink: 0;\n}\n\n.status-badge::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--color-text-secondary);\n}\n\n.status-completed::before {\n  background: #4f9f6c;\n}\n\n.status-processing::before {\n  background: #d69a44;\n}\n\n.status-failed::before {\n  background: #c85e55;\n}\n\n.status-unknown::before {\n  background: var(--color-text-secondary);\n}\n\n/* ======================\n   PAGINATION\n   ====================== */\n\n.projects-pagination {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.projects-pagination-info {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  font-weight: 400;\n}\n\n.projects-pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.projects-pagination-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.projects-pagination-btn:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.projects-pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.projects-pagination-pages {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.projects-pagination-page {\n  min-width: 28px;\n  height: 28px;\n  padding: 0 8px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.projects-pagination-page:hover:not(.active) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.projects-pagination-page.active {\n  background: var(--color-bg-input);\n  border-color: var(--color-border-input);\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n.projects-pagination-ellipsis {\n  min-width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n}\n\n/* ======================\n   LANDING MODAL\n   ====================== */\n\n.projects-landing-modal {\n  position: fixed;\n  inset: 0;\n  background: var(--color-bg-root);\n  z-index: 1000;\n  overflow-y: auto;\n}\n\n.projects-landing-modal-close {\n  position: fixed;\n  top: 16px;\n  left: 16px;\n  z-index: 1001;\n  padding: 8px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.projects-landing-modal-close:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* ======================\n   CARD CONTEXT MENU\n   ====================== */\n\n.projects-context-menu-content {\n  min-width: 160px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  padding: 4px;\n  z-index: 2000;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  animation: projects-context-menu-fade 0.1s ease;\n}\n\n@keyframes projects-context-menu-fade {\n  from { opacity: 0; transform: scale(0.97); }\n  to   { opacity: 1; transform: scale(1); }\n}\n\n.projects-context-menu-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  border-radius: 3px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  cursor: pointer;\n  user-select: none;\n  outline: none;\n  color: var(--color-text-primary);\n}\n\n.projects-context-menu-item[data-highlighted] {\n  background: var(--color-bg-user-bubble);\n}\n\n.projects-context-menu-item-destructive {\n  color: #c0392b;\n}\n\n.projects-context-menu-item-destructive[data-highlighted] {\n  background: rgba(192, 57, 43, 0.08);\n}\n\n/* ======================\n   DELETE CONFIRMATION DIALOG\n   ====================== */\n\n.projects-delete-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 3000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.projects-delete-dialog {\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  padding: 24px;\n  width: 340px;\n  max-width: calc(100vw - 32px);\n}\n\n.projects-delete-dialog-title {\n  margin: 0 0 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n}\n\n.projects-delete-dialog-body {\n  margin: 0 0 20px;\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  line-height: 1.5;\n}\n\n.projects-delete-dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.projects-delete-dialog-cancel {\n  padding: 7px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: transparent;\n  color: var(--color-text-secondary);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.projects-delete-dialog-cancel:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.projects-delete-dialog-cancel:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.projects-delete-dialog-confirm {\n  padding: 7px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: rgba(192, 57, 43, 0.1);\n  color: #c0392b;\n  border: 1px solid rgba(192, 57, 43, 0.25);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.projects-delete-dialog-confirm:hover:not(:disabled) {\n  background: rgba(192, 57, 43, 0.18);\n}\n\n.projects-delete-dialog-confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ======================\n   RESPONSIVE\n   ====================== */\n\n@media (max-width: 900px) {\n  .projects-list-header {\n    display: none;\n  }\n\n  .projects-row {\n    grid-template-columns: minmax(0, 1fr) 32px;\n    align-items: start;\n    gap: 12px;\n    min-height: 0;\n    padding: 16px;\n  }\n\n  .projects-row-project {\n    grid-column: 1;\n  }\n\n  .projects-row-actions-button {\n    grid-column: 2;\n    grid-row: 1;\n  }\n\n  .projects-row-creator,\n  .projects-row-status,\n  .projects-row-date,\n  .projects-row-cost {\n    grid-column: 1 / -1;\n    display: grid;\n    grid-template-columns: 96px minmax(0, 1fr);\n    align-items: center;\n    gap: 8px;\n  }\n\n  .projects-row-creator {\n    grid-template-columns: 96px 24px minmax(0, 1fr);\n  }\n\n  .projects-mobile-label {\n    display: inline;\n    color: var(--color-text-secondary);\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  .projects-skeleton-row {\n    grid-template-columns: 1fr;\n  }\n\n  .projects-skeleton-row > :not(:first-child) {\n    display: none;\n  }\n}\n\n@media (max-width: 720px) {\n  .projects-content {\n    padding: 20px 16px;\n  }\n\n  .projects-header-section {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .projects-new-button {\n    width: 100%;\n  }\n\n  .projects-filters {\n    flex-direction: column;\n  }\n\n  .projects-search,\n  .projects-status-filter {\n    width: 100%;\n  }\n\n  .projects-pagination-controls {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .projects-pagination-btn {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n\n  .projects-pagination-page {\n    min-width: 26px;\n    height: 26px;\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
